<template>
  <div>
    <div class="search-content">
      <div class="content-head">
        <img src="/image/notice.png" v-if="title=='搜索结果'" alt />
        <img src="/image/notice2.png" v-else alt />
        <span>{{title}}</span>
      </div>
      <div class="content-body" v-for="(item,index) in noticeList" :key="index">
        <div
          @click="item.articleLink?openInNewTab(item.articleLink):chooseNotice(item)"
          class="content-item"
          @mouseleave="leaveNotice"
          :class="{ active:noticeIndex == index }"
          @mouseenter="enterNotice(index)"
        >
          <img src="/image/icon1.png" alt />
          <div class="text-box">
            <p class="p1">{{item.title}}</p>
            <p class="p2">发布时间：{{item.effectStartTime!=null?item.effectStartTime.split(" ")[0]:''}}</p>
          </div>
        </div>
      </div>
      <div v-if="noticeList == '' && title=='搜索结果'">
        <br />
        <p>
          找不到与您的查询
          <strong style="font-weight: bold;">“{{$route.query.title}}”</strong> 相符的
        </p>
        <br />
        <p>建议：</p>
        <br />
        <p>请检查输入词是否错误</p>
        <p>请换用另外的查询字词</p>
        <p>请改用较常见的字词</p>
      </div>
      <div class="content-footer" :class="{nothing:noticeList==''}">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="1"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  //给组件起一个名字,开发者工具中显示这个组件的时候，显示的就是这个名字
  // eslint-disable-next-line vue/multi-word-component-names
  name: "noticeBox",
  props: {
    title: {
      type: String,
      default: ""
    },
    noticeList: {
      type: Array,
      default: () => []
    },
    total: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      noticeIndex: -1,
      pageSize: 10
      // pageNo: 5
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.$emit("changePageSize", val);
    },
    handleCurrentChange(val) {
      this.$emit("changePageNo", val);
    },
    enterNotice(index) {
      this.noticeIndex = index;
    },
    leaveNotice() {
      this.noticeIndex = -1;
    },
    chooseNotice(item) {
      // console.log(item);
      this.$router.push({
        name: "detail",
        query: { id: item.id }
      });
    },
    // openInNewTab(link) {
    //   window.open(link, '_blank');
    // }
    openInNewTab(link) {
      var a = document.createElement("a");
      a.href = link;
      a.target = "_blank";
      a.rel = "noopener noreferrer";

      document.body.appendChild(a); // 将a元素添加到body
      a.click(); // 模拟点击
      document.body.removeChild(a); // 移除a元素
    }
  }
};
</script>

<style scoped lang="less">
.search-content {
  padding: 24px 62px 40px 62px;
  background: #ffffff;
  border-radius: 8px 8px 8px 8px;
  .content-head {
    padding-bottom: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    border-bottom: 2px solid rgba(18, 68, 155, 0.2);
    img {
      width: 30px;
      height: 30px;
    }
    span {
      margin-left: 5px;
      font-size: 24px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #0052d9;
      line-height: 34px;
    }
  }
  .content-body {
    // margin-bottom: 24px;
    .content-item {
      padding: 20px 0;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(18, 68, 155, 0.2);
      cursor: pointer;
      img {
        width: 24px;
        height: 24px;
      }
      .text-box {
        margin-left: 8px;
        .p1 {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #333333;
          line-height: 22px;
          display: -webkit-box;
          overflow: hidden; /*超出隐藏*/
          text-overflow: ellipsis; /*隐藏后添加省略号*/
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 1; /*想显示多少行*/
        }
        .p2 {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #999999;
          line-height: 18px;
        }
      }
    }
    .active {
      box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
    }
  }
  .content-footer {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
  }
  .nothing {
    margin-top: 100px;
  }
}

/* 大型桌面端样式 */
@media only screen and (min-width: 993px) {
  .search-content {
    padding: 24px 62px 40px 62px;
    background: #ffffff;
    border-radius: 8px 8px 8px 8px;
    .content-head {
      padding-bottom: 24px;
      width: 100%;
      display: flex;
      align-items: center;
      border-bottom: 2px solid rgba(18, 68, 155, 0.2);
      img {
        width: 30px;
        height: 30px;
      }
      span {
        margin-left: 5px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #0052d9;
        line-height: 34px;
      }
    }
    .content-body {
      // margin-bottom: 24px;
      .content-item {
        padding: 20px 0;
        display: flex;
        align-items: center;
        border-bottom: 2px solid rgba(18, 68, 155, 0.2);
        cursor: pointer;
        img {
          width: 24px;
          height: 24px;
        }
        .text-box {
          margin-left: 8px;
          .p1 {
            font-size: 16px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 22px;
            display: -webkit-box;
            overflow: hidden; /*超出隐藏*/
            text-overflow: ellipsis; /*隐藏后添加省略号*/
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 1; /*想显示多少行*/
          }
          .p2 {
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #999999;
            line-height: 18px;
          }
        }
      }
      .active {
        box-shadow: 0px 2px 4px 0px rgba(98, 115, 197, 0.3);
      }
    }
    .content-footer {
      margin-top: 24px;
      display: flex;
      justify-content: flex-end;
    }
    .nothing {
      margin-top: 100px;
    }
  }
}
</style>
